import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    {
      /* 临时拿一个图标充数 */
    }
    <p align="center"><a href="https://www.baidu.com"><img alt="hui-ui logo" src="https://ftp.bmp.ovh/imgs/2020/03/0de4eeb164d6fedb.jpg" /></a></p>
    <p align="center"></p>
    <h1 {...{
      "id": "hui-ui"
    }}>{`hui-ui`}</h1>
    <p align="center">
  <a href="https://github.com/hellojackhui/hui-ui" rel="nofollow" target="_blank">
    <img alt="NPM" src="https://img.shields.io/npm/l/hui-ui" />
  </a>
  <a href="https://nodejs.org/en/" rel="nofollow" target="_blank">
    <img alt="node-current" src="https://img.shields.io/node/v/v" />
  </a>
  <a href="https://github.com/facebook/react" rel="nofollow" target="_blank">
    <img alt="react-version" src="https://img.shields.io/badge/react-16.11.0-brightgreen" />
  </a>
  <a href="https://github.com/webpack/webpack" rel="nofollow" target="_blank">
    <img alt="webpack version" src="https://img.shields.io/badge/webpack-4.41.5-brightgreen" />
  </a>
  <a href="https://github.com/hellojackhui/hui-ui" rel="nofollow" target="_blank">
    <img alt="GitHub followers" src="https://img.shields.io/github/followers/hellojackhui?style=social" />
  </a>
  <a href="https://github.com/hellojackhui/hui-ui" rel="nofollow" target="_blank">
    <img alt="build passing" src="https://img.shields.io/badge/build-passing-brightgreen" />
  </a>
  
    </p>
    <p><inlineCode parentName="p">{`hui-ui`}</inlineCode>{`是一款基于`}<a parentName="p" {...{
        "href": "https://reactjs.org/"
      }}>{`React`}</a>{`开发的组件库,组件库提供了丰富的通用性组件，可以提升团队组件化开发的效率，提升用户体验。`}</p>
    <h2 {...{
      "id": "组件库文档地址持续更新中"
    }}>{`组件库文档地址(持续更新中)`}</h2>
    <p><a parentName="p" {...{
        "href": "https://hui-ui.netlify.app"
      }}>{`https://hui-ui.netlify.app`}</a></p>
    <h2 {...{
      "id": "开发计划"
    }}>{`开发计划`}</h2>
    <ul>
      <li parentName="ul">{`完成所有基础组件的开发与测试`}</li>
      <li parentName="ul">{`完善测试用例和文档编写`}</li>
      <li parentName="ul">{`完成css的整体架构调整`}</li>
      <li parentName="ul">{`完成example文档编写`}</li>
      <li parentName="ul">{`部署上线`}</li>
    </ul>
    <h2 {...{
      "id": "特性"
    }}>{`特性`}</h2>
    <ul>
      <li parentName="ul">{`:book: `}<strong parentName="li">{`文档`}</strong>{`: 完善的使用文档`}</li>
      <li parentName="ul">{`:art: `}<strong parentName="li">{`设计`}</strong>{`: 精美的风格设计`}</li>
      <li parentName="ul">{`:rocket: `}<strong parentName="li">{`技术栈`}</strong>{`: 使用前沿的前端技术栈`}</li>
      <li parentName="ul">{`:gem: `}<strong parentName="li">{`配置`}</strong>{`:  开发的组件配置`}</li>
      <li parentName="ul">{`:gear: `}<strong parentName="li">{`工程化`}</strong>{`: 良好的工程化实践`}</li>
    </ul>
    <h2 {...{
      "id": "兼容性"
    }}>{`兼容性`}</h2>
    <p>{`现代浏览器及IE11以上版本`}</p>
    <h2 {...{
      "id": "参与贡献"
    }}>{`参与贡献`}</h2>
    <p>{`非常欢迎你的贡献，你可以通过以下方式共同建设组件库`}</p>
    <ul>
      <li parentName="ul">{`通过`}<a parentName="li" {...{
          "href": "https://github.com/hellojackhui/hui-ui/issues"
        }}>{`issue`}</a>{`进行提问`}</li>
      <li parentName="ul">{`通过提交`}<a parentName="li" {...{
          "href": "https://github.com/hellojackhui/hui-ui/pulls"
        }}>{`request`}</a>{`改进代码`}</li>
    </ul>
    <h2 {...{
      "id": "文档更新进度"
    }}>{`文档更新进度`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`开发者`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`修改内容`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`时间`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`惠嘉伟`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`基础版`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2020-03-05`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`惠嘉伟`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`搭建docz文档系统`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2020-04-16`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`惠嘉伟`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`netlify静态文档基本完成`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2020-04-27`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`惠嘉伟`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`开始完善现有组件的测试用例`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`2020-05-10`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      